module.exports = __webpack_public_path__ + "assets/images/confirm-email-mobile.810f5ff9ca5c9dc980d16f06c4cae80f.webp";